import { IPromptSuggestion } from './types';

export const promptSuggestion: Array<IPromptSuggestion> = [
  {
    id: 0,
    iconName: 'TipsAndUpdatesOutlined',
    title: 'SUGESTÕES DE COMANDOS',
  },
  {
    id: 1,
    iconName: 'PsychologyAltOutlined',
    title: 'O QUE A GREENFY A.I É CAPAZ DE FAZER?',
  },
  {
    id: 2,
    iconName: 'AutoModeOutlined',
    title: 'COMANDOS MAIS USADOS ',
  },
];
